<template>
  <div class="user-header">
    <!-- 根据游戏来使用对应的icon -->
    <!-- <van-image class="left" round :src="userHeaderImg" /> -->
    <!-- 通用游戏icon -->
    <SvgRender class="left" :iconSvg="commonGameSvgIcon"></SvgRender>
    <div class="right">
      <p class="role">{{ roleName }}</p>
      <p class="game">
        <span>{{ gameName }}</span>
        <span v-if="serverName">&nbsp-&nbsp</span>
        <span>{{ serverName }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import SvgRender from './common/SvgRender.vue';

export default {
  name: 'UserHeader',
  props: {
    roleName: {
      type: String,
      default: ''
    },
    gameName: {
      type: String,
      default: ''
    },
    serverName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // iconSrc: require('@assets/image/sdkSkin/user_icon.png'),
      commonGameSvgIcon:
        '<?xml version="1.0" encoding="UTF-8"?><svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 23C26.7614 23 29 20.7614 29 18C29 15.2386 26.7614 13 24 13C21.2386 13 19 15.2386 19 18C19 20.7614 21.2386 23 24 23Z" fill="none" stroke="#333" stroke-width="4" stroke-linejoin="round"/><path d="M10.022 38.332C10.3657 33.1206 14.7016 29 20 29H28C33.2914 29 37.6229 33.1097 37.9767 38.3113" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };
  },
  // computed: {
  //   // 根据游戏来使用对应的头像
  //   userHeaderImg() {
  //     const PIC_URL_LIST =
  //       this.$store.state?.sdkSkin?.configSkinData?.PIC_URL_LIST;
  //     const configImg =
  //       PIC_URL_LIST && PIC_URL_LIST?.hasOwnProperty('user_icon.png')
  //         ? PIC_URL_LIST['user_icon.png']
  //         : '';
  //     return configImg || this.iconSrc;
  //   }
  // },
  components: {
    SvgRender
  }
};
</script>

<style lang="scss" scoped>
.user-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 104px;
  padding-left: 17px;
  background-color: var(--block-bg-color);

  .left {
    width: 80px;
    height: 80px;
  }
  .right {
    margin-left: 21px;
    .role {
      margin-bottom: 7px;
      font-size: 15px;
    }
    .game {
      font-size: 12px;
      color: var(--placeholder-color);
    }
  }
}
</style>
